import { render, staticRenderFns } from "./ProportionalDividend.marginInfo.vue?vue&type=template&id=1ffd78d1&"
import script from "WX/components/proportionalDividend/proportionalDividend.component.marginInfo?vue&type=script&lang=js&"
export * from "WX/components/proportionalDividend/proportionalDividend.component.marginInfo?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports